import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  CUE_ATOL_PROTECTED,
  ATOL_LOGO_ALT,
  CUE_ATOL_INSTANT,
} from '../../brands/default/content/components/checkout';
import { ATOL_LOGO } from '../../config/constants/images';
import CheckoutSocialCue from './SocialCue';

const BasketSocialCuesAtol = ({ className, isLighter }) => (
  <>
    <div className={classNames('social-cues', 'atol-protected', className)}>
      <img alt={ATOL_LOGO_ALT} className="atol-logo" src={ATOL_LOGO} />
      <div className="cues">
        <CheckoutSocialCue
          isLighter={isLighter}
          text={CUE_ATOL_PROTECTED}
          type="assure"
        />
        <CheckoutSocialCue
          isLighter={isLighter}
          text={CUE_ATOL_INSTANT}
          type="assure"
        />
      </div>
    </div>
    <style jsx>{`
      .atol-protected {
        display: flex;
        align-items: center;
      }
      .atol-logo {
        height: 49px;
        width: 49px;
        margin-right: 20px;
      }
      .with-margin {
        margin: 15px 0;
      }
    `}</style>
  </>
);

BasketSocialCuesAtol.propTypes = {
  className: PropTypes.string,
  isLighter: PropTypes.bool,
};

BasketSocialCuesAtol.defaultProps = {
  isLighter: false,
};

export default BasketSocialCuesAtol;
